import { setUserCardClosed } from './actions';
import { TThunkAction } from '../../types/redux/thunk';

export const closeUserCard = (): TThunkAction<void> => dispatch => {
  dispatch(setUserCardClosed());
};
